var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 218,
    viewBox: "0 0 154 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.931 48.0474H129.752",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2474 48.0474H5.06836",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6047 83.8756C62.6018 84.6794 62.5475 85.4821 62.4424 86.279C61.8376 90.5893 59.5779 94.4978 56.1385 97.1815C52.6991 99.8653 48.3484 101.115 44.0026 100.667C39.6569 100.22 35.6551 98.1103 32.8394 94.7825C30.0238 91.4547 28.6141 87.1684 28.9072 82.826C29.2002 78.4836 31.173 74.4238 34.4104 71.5014C37.6479 68.579 41.8974 67.0219 46.2641 67.1579C50.6309 67.2939 54.7743 69.1124 57.8221 72.2306C60.87 75.3488 62.5846 79.5235 62.6047 83.8756Z",
    fill: "white",
    fillOpacity: 0.13,
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.947 83.8757C124.947 84.1584 124.947 84.4614 124.947 84.7441C124.724 88.8847 122.964 92.7948 120.01 95.7158C117.055 98.6367 113.117 100.36 108.959 100.551C104.801 100.743 100.72 99.3882 97.508 96.7509C94.2959 94.1136 92.182 90.3815 91.5765 86.279C91.4714 85.4822 91.4173 84.6794 91.4144 83.8757C91.3361 81.6321 91.7121 79.3958 92.5199 77.3C93.3278 75.2042 94.551 73.292 96.1166 71.6772C97.6822 70.0624 99.5581 68.7782 101.633 67.9011C103.707 67.024 105.938 66.572 108.191 66.572C110.445 66.572 112.675 67.024 114.75 67.9011C116.824 68.7782 118.7 70.0624 120.266 71.6772C121.831 73.292 123.054 75.2042 123.862 77.3C124.67 79.3958 125.046 81.6321 124.968 83.8757H124.947Z",
    fill: "white",
    fillOpacity: 0.13,
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.752 48.1482H24.3281L54.232 7.1091C54.9854 6.08685 56.1151 5.40424 57.3733 5.21112C58.6315 5.018 59.9152 5.33014 60.9425 6.07906C61.2803 6.33125 61.5868 6.62279 61.855 6.94749L69.5995 15.8946C70.3875 16.8734 71.3613 17.6879 72.4654 18.2917C73.5694 18.8955 74.7821 19.2768 76.0341 19.4137C77.286 19.5506 78.5527 19.4405 79.7619 19.0896C80.9711 18.7388 82.0993 18.1541 83.0816 17.3689C83.6247 16.9296 84.1206 16.4356 84.5616 15.8946L92.3061 6.94749C93.1053 5.96154 94.263 5.32986 95.5273 5.18992C96.7917 5.04997 98.0605 5.41309 99.0574 6.20023C99.3789 6.47225 99.6709 6.77686 99.9291 7.1091L129.752 48.1482Z",
    fill: "white",
    fillOpacity: 0.13,
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.928 84.7442V106.718C124.922 113.853 122.076 120.694 117.013 125.741C111.951 130.788 105.085 133.629 97.9229 133.64H56.0574C52.5094 133.64 48.9962 132.943 45.7185 131.59C42.4408 130.237 39.463 128.253 36.9551 125.753C34.4472 123.253 32.4586 120.285 31.1026 117.019C29.7467 113.753 29.0501 110.252 29.0527 106.718V83.8757C29.0666 88.0927 30.6793 92.1488 33.5678 95.2315C36.4564 98.3143 40.4074 100.196 44.6296 100.5C48.8518 100.804 53.0334 99.5075 56.3368 96.8704C59.6402 94.2333 61.8214 90.4503 62.4437 86.2791H91.5569C92.1623 90.3816 94.2763 94.1136 97.4883 96.7509C100.7 99.3883 104.781 100.743 108.939 100.551C113.097 100.36 117.036 98.6368 119.99 95.7159C122.945 92.7949 124.704 88.8847 124.928 84.7442Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.928 84.7442V83.8757",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9221 133.539L76.9792 212.951L56.0566 133.539H97.9221Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.98 212.951L28.0998 154.987L19.1387 144.364L37.5272 126.187C42.5323 130.907 49.1655 133.531 56.0572 133.519L76.98 212.951Z",
    fill: "white",
    fillOpacity: 0.13,
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.842 144.364L125.881 154.967L76.9805 212.951L97.9232 133.539C104.81 133.556 111.439 130.931 116.433 126.207L134.842 144.364Z",
    fill: "white",
    fillOpacity: 0.13,
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9807 212.951H4.98831V202.227C4.97938 193.128 7.04838 184.147 11.0385 175.963C15.0287 167.778 20.8354 160.606 28.0193 154.987L76.9807 212.951Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148.932 202.227V212.951H76.9805L125.881 154.967C133.074 160.583 138.887 167.758 142.882 175.947C146.876 184.135 148.945 193.123 148.932 202.227Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetective);
export default __webpack_public_path__ + "static/media/detective.fe6010e29560fcf831468acafc6e7b10.svg";
export { ForwardRef as ReactComponent };